import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Sparkles, BookOpen, Headphones, TrendingUp } from 'lucide-react';
import { cn } from '../../ui/utils';

export const MobileBottomNav: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { to: '/dashboard', label: 'Home', icon: Sparkles },
    { to: '/training', label: 'Learn', icon: BookOpen },
    { to: '/simulator/call/SCEN-SIM-01', label: 'Practice', icon: Headphones },
    { to: '/performance', label: 'Progress', icon: TrendingUp },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-surface-1/95 backdrop-blur-md border-t border-border-subtle/80 flex items-center justify-around px-2 z-40"
      aria-label="Mobile Bottom Navigation"
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive =
          item.to === '/dashboard'
            ? location.pathname === '/dashboard' || location.pathname === '/'
            : location.pathname.startsWith(item.to.split('/')[1] ? `/${item.to.split('/')[1]}` : item.to);

        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive: matchActive }) =>
              cn(
                'flex flex-col items-center justify-center min-w-[56px] min-h-[48px] py-1 px-2 rounded-xl transition-all',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus',
                matchActive || isActive
                  ? 'text-brand font-semibold scale-105'
                  : 'text-foreground-muted hover:text-foreground-secondary'
              )
            }
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon className="w-5 h-5 mb-0.5" />
            <span className="text-[11px] tracking-tight">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};
